<template>
    <div v-if="chatDataCenter.leaveMessage.show">
        <!--留言-->
        <div class="smartnlp-mask"></div>
        <div :class="chatDataCenter.set.windowSize=='1'?'smartnlp-leaveWords':'smartnlp-leaveWords1'">
            <div class="smartnlp-dialog-title">请填写留言<a><img src="../../../static/images/m-c.png" style="width: 10px;height: 10px;" @click="chatDataCenter.leaveMessage.show=false"></a></div>
            <div class="shouming">很抱歉我们暂时无法为您提供服务，如需帮助请留言，我们将尽快回复解决您的问题</div>
            <div class="smartnlp-dialog-content">
                <div class="smartnlp-leaveWords-list" v-if="messageConfiguration=='2'">
                    <div class="smartnlp-leaveWords-label"><span>*</span>咨询类型</div>
                    <div class="smartnlp-leaveWords-right">
                        <select v-model.trim="leaveMessage.consultLeaveId" placeholder="请选择留言咨询类型">
                            <option :value="item.consultLeaveId" :label="item.name" v-for="(item, index) in leaveConsultTypeList"></option>
                        </select>
                    </div>
                </div>
<!--                <div class="smartnlp-leaveWords-list" v-if="messageConfiguration=='2'">-->
<!--                    <div class="smartnlp-leaveWords-label"><span>*</span>类型描述</div>-->
<!--                    <div class="smartnlp-leaveWords-right"><p v-for="(item, index) in leaveConsultTypeList">{{item.name}}：{{item.remark}}</p></div>-->
<!--                </div>-->
                <div class="smartnlp-leaveWords-list">
                    <div class="smartnlp-leaveWords-label"><span>*</span>联系人</div>
                    <div class="smartnlp-leaveWords-right"><input v-model.trim="leaveMessage.name" :maxlength="20" type="text">
                    </div>
                </div>
                <div class="smartnlp-leaveWords-list">
                    <div class="smartnlp-leaveWords-label"><span>*</span>手机</div>
                    <div class="smartnlp-leaveWords-right"><input v-model.trim="leaveMessage.tel" :maxlength="11" type="text" ></div>
                </div>
                <div class="smartnlp-leaveWords-list">
                    <div class="smartnlp-leaveWords-label"><span></span>邮箱</div>
                    <div class="smartnlp-leaveWords-right"><input v-model.trim="leaveMessage.email" :maxlength="20" type="text"> </div>
                </div>
                <div class="smartnlp-leaveWords-list1">
                    <div class="smartnlp-leaveWords-label" style="vertical-align: top"><span>*</span>留言内容</div>
                    <div class="smartnlp-leaveWords-right"><textarea :maxlength="200" v-model.trim="leaveMessage.remark"></textarea></div>
                </div>
                <div class="smartnlp-leaveWords-submit">
                    <button type="button"  @click="save()" v-btn-control="3000" :style="'background:'+ chatDataCenter.linkInfo.windowColor">提交</button>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import chatDataCenter from "../../jsSdk/chatDataCenter";
    export default {
        name: "leave-message",
        data() {
            return {
                chatDataCenter,
                leaveMessage:{
                    tel:chatDataCenter.customer!=null?chatDataCenter.customer.tel:'',
                    name:chatDataCenter.customer!=null?chatDataCenter.customer.nickName:'',
                    email:chatDataCenter.customer!=null?chatDataCenter.customer.email:'',
                    remark:"",
                    consultLeaveId:null,
                },
                leaveConsultTypeList:[]
            }
        },
        computed:{
            leaveShow() {
                return chatDataCenter.leaveMessage.show
            },
            messageConfiguration() {
                if (chatDataCenter.channelInfo==null){
                    return '1'
                }
                if (chatDataCenter.channelInfo.messageConfiguration==undefined
                    ||chatDataCenter.channelInfo.messageConfiguration==null){
                    return '1'
                }
                return chatDataCenter.channelInfo.messageConfiguration+''
            },
        },
        watch:{
            leaveShow:{
                handler(curVal,oldVal){
                    if(curVal!=undefined&&curVal){
                        var _this = this;
                        if (chatDataCenter.channelInfo!=null){
                            if (chatDataCenter.channelInfo.messageConfiguration==2||chatDataCenter.channelInfo.messageConfiguration=='2'){
                                chatDataCenter.getConsultTypeLeaveList(chatDataCenter.customer.sourceChannelId,function (data) {
                                    if (data.code==0){
                                        _this.leaveConsultTypeList=data.data
                                    }
                                });
                            }
                        }
                    }
                },
                deep: true,
                immediate:true
            },
        },
        methods:{
            save:function () {
                var _this = this;
                if (_this.messageConfiguration=='2'){
                    if(_this.leaveMessage.consultLeaveId==null||_this.leaveMessage.consultLeaveId==''){
                        _this.$messageBox.Error({message:'请选择留言类型',duration:3000});
                        return;
                    }
                }
                if(_this.leaveMessage.name==''){
                    this.$messageBox.Error({message:'请填写联系人',duration:3000});
                    return;
                }
                if(_this.leaveMessage.tel==''){
                    this.$messageBox.Error({message:'请填写手机',duration:3000});
                    return;
                }
                var telReg =/^1\d{10}$/;
                if(!telReg.test(_this.leaveMessage.tel)){
                    this.$messageBox.Error({message:'手机格式不正确',duration:3000});
                    return;
                }
                if(_this.leaveMessage.email!=''){
                    var emailReg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
                    if(!emailReg.test(_this.leaveMessage.email)){
                        this.$messageBox.Error({message:'邮箱格式不正确',duration:3000});
                        return;
                    }
                }
                if(_this.leaveMessage.remark==''){
                    this.$messageBox.Error({message:'请填写留言内容',duration:3000});
                    return;
                }
                var saveData={
                    companyId:chatDataCenter.customer.companyId,
                    customerChannelId:chatDataCenter.customer.customerChannelId,
                    customId:chatDataCenter.customer.customerId,
                    channelId:chatDataCenter.customer.sourceChannelId,
                    context:(_this.leaveMessage.remark),
                    tel:(_this.leaveMessage.tel),
                    contactName:(_this.leaveMessage.name),
                    email:(_this.leaveMessage.email)
                }
                if(chatDataCenter.leaveMessage.sessionId!=null){
                    saveData.sessionId=chatDataCenter.leaveMessage.sessionId
                }
                if(_this.leaveMessage.consultLeaveId!=null){
                    saveData.consultLeaveId=_this.leaveMessage.consultLeaveId
                }
                _this.$axiosService.post('leaveMsg/saveLeaveMsg', saveData, response => {
                    if (response.code==0) {
                        this.$messageBox.Success({message:"已提交留言",duration:3000});
                        chatDataCenter.leaveMessage.show=false
                    }else{
                        this.$messageBox.Error({message:response.msg,duration:3000});
                    }
                });
            }
        },
    }
</script>

<style scoped>
    @import "../../../static/css/main.css";
</style>
